// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"da365c16","781":"98ca6887","845":"4158f5ea","850":"2594ae69"}[chunkId] + ".chunk.js";
};